const SCORE_THRESHOLD_SUCCESS = 75;
const SCORE_THRESHOLD_WARNING = 25;
export const parseScoreValue = (value) => {
    if (typeof value === "number" && Number.isFinite(value)) {
        return value;
    }
    if (typeof value === "string") {
        const sanitized = value.replace(/[^0-9.-]/g, "");
        if (!sanitized)
            return null;
        const parsed = Number.parseFloat(sanitized);
        if (Number.isFinite(parsed)) {
            return parsed;
        }
    }
    return null;
};
export const getScoreColor = (score) => {
    if (score >= SCORE_THRESHOLD_SUCCESS)
        return "success";
    if (score >= SCORE_THRESHOLD_WARNING)
        return "warning";
    return "error";
};
export const getScoreStatusFromValue = (value) => {
    const parsed = parseScoreValue(value);
    if (parsed === null)
        return undefined;
    if (parsed < 0 || parsed > 100)
        return undefined;
    return getScoreColor(parsed);
};
